export const GRAPH_LINK_DISTANCE = 58;
export const GRAPH_CHARGE_STRENGTH = -155;
export const GRAPH_CENTER_STRENGTH = 0.04;
export const GRAPH_NODE_SIZE = 26;
export const GRAPH_COLLISION_RADIUS = 29;
export const GRAPH_COLLISION_STRENGTH = 0.92;
export const GRAPH_COLLISION_ITERATIONS = 3;
